export default {
    SET_CURRENT_CONTACT (state, contact){
        state.current_contact = contact
    },

    SET_CONTACT_LIST (state, contacts) {
        state.list = contacts
    }
}